import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const UHL_LOGO =
  "https://customer-assets.emergentagent.com/job_ubl-hoops/artifacts/guzx5yt0_ChatGPT%20Image%20Apr%2020%2C%202026%2C%2009_02_19%20AM.png";

const navItems = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/program", label: "Program" },
  { to: "/register", label: "Register" },
  { to: "/volunteer", label: "Volunteer" },
  { to: "/forms", label: "Forms" },
  { to: "/donate", label: "Donate" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-white/85 backdrop-blur-xl border-b border-slate-100"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex items-center justify-between h-20">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-3"
          onClick={() => setOpen(false)}
          aria-label="Unified Hoops League — Home"
        >
          <img
            src={UHL_LOGO}
            alt="UHL — Unified Hoops League"
            className="h-12 sm:h-14 w-auto object-contain"
          />
          <span className="sr-only">UHL — Unified Hoops League</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-3 py-2 rounded-full font-bold text-sm transition-all ${
                  isActive
                    ? "bg-blue-50 text-blue-600"
                    : "text-slate-600 hover:text-blue-600 hover:bg-slate-50"
                }`
              }
              end={item.to === "/"}
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/register"
            data-testid="nav-register-cta"
            className="ml-3 bg-orange-500 text-white hover:bg-orange-600 hover:shadow-lg hover:-translate-y-0.5 transition-all font-bold px-6 py-2.5 rounded-full text-sm"
          >
            Join Interest List
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          className="lg:hidden p-2 rounded-full hover:bg-slate-100 transition-colors"
        >
          {open ? (
            <X className="w-6 h-6 text-slate-700" />
          ) : (
            <Menu className="w-6 h-6 text-slate-700" />
          )}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-100 bg-white">
          <div className="px-6 py-4 flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`mobile-nav-link-${item.label.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-2xl font-bold transition-colors ${
                    isActive
                      ? "bg-blue-50 text-blue-600"
                      : "text-slate-700 hover:bg-slate-50"
                  }`
                }
                end={item.to === "/"}
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/register"
              data-testid="mobile-nav-register-cta"
              onClick={() => setOpen(false)}
              className="mt-2 bg-orange-500 text-white text-center font-bold px-6 py-3 rounded-full"
            >
              Join Interest List
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
